import FieldFilter from './src/field_filter';

export default FieldFilter;



// WEBPACK FOOTER //
// ./src/components/field_filter/index.js